<template>
  <v-dialog v-model="openDialog" max-width="400" lazy>
    <v-card>
      <v-card-title class="title">
        Attach {{ $t('terms.bill-of-lading') }}
      </v-card-title>
      <v-layout column class="px-3">
        <v-layout column class="pr-5">
          <v-text-field :label="billOfLadingNumberFieldLabel"
                        v-model="billOfLadingNumber"
                        :error-messages="errors.first('bolNumber')"
                        :data-vv-as="billOfLadingNumberFieldLabel"
                        data-vv-name="bolNumber"
                        :class="{'pb-2': errors.any()}"
                        v-validate.immediate="{ required: true, alpha_dash: true }">
          </v-text-field>
        </v-layout>

        <files-upload-btn @upload="uploadBOL($event)"
                          v-if="openDialog"
                          btn-class="primary mx-0"
                          :uploading-progress="uploadPercentage"
                          multiple
                          :disabled="errors.any()">
        </files-upload-btn>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn flat color="accent" @click="openDialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import API from '@/api/index';

import FilesUploadBtn from '@/components/FilesUploadBtn';
import pluginMixin from '../../mixins/pluginMixin';

export default {
  name: 'UploadBillOfLadingDialog',
  props: {
    value: {
      type: Boolean,
    },
    loadId: {
      type: String,
    },
  },
  data() {
    return {
      openDialog: this.value,
      billOfLadingNumber: null,
      uploadPercentage: null,
    };
  },
  mixins: [
    pluginMixin,
  ],
  components: {
    FilesUploadBtn,
  },
  watch: {
    value() {
      this.openDialog = this.value;
      if (this.value) {
        this.resetForm();
      }
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  computed: {
    billOfLadingNumberFieldLabel() {
      return `${this.$t('terms.bill-of-lading')} Number`;
    },
  },
  methods: {
    resetForm() {
      this.billOfLadingNumber = null;
      this.uploadPercentage = null;
      this.$validator.reset();
    },
    async uploadBOL(base64Files) {
      try {
        console.log("BOL: " + this.billOfLadingNumber);
        const isValid = await this.$validator.validateAll();
        if (isValid) {
          this.uploadPercentage = 1;

          const config = {
            onUploadProgress: (progressEvent) => {
              this.uploadPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            },
          };

          const doc = this.currentActivePlugins.locality.is_aus ? 'DeliveryDocket' : 'BillOfLading';

          await API.load.uploadBOL({
            billOfLadingBase64s: base64Files,
            billOfLadingNumber: this.billOfLadingNumber,
            loadId: this.loadId,
            doc: doc,
            config,
          });

          this.$emit('refresh');
          this.openDialog = false;
        }
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.uploadPercentage = null;
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/UploadBillofLadingDialog.vue